import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ogdensburgConfig } from "./data";

export default function OgdensburgPage() {
  return <CityPageTemplate config={ogdensburgConfig} />;
}